/**
 * Re-fetches the active (unresolved) incident count for the current
 * organization. Dispatched on app start and after incident mutations; a
 * successful load emits `ActiveIncidentCountChanged`.
 */
export class LoadActiveIncidentCount {
  static readonly type = '[IncidentActivity] Load Active Incident Count';
}

/**
 * Push entry point for count updates: today emitted by
 * `LoadActiveIncidentCount`, later also by the incident GraphQL subscription
 * (and whatever else observes incident activity in realtime, e.g. toasts).
 */
export class ActiveIncidentCountChanged {
  static readonly type = '[IncidentActivity] Active Incident Count Changed';
  constructor(public count: number) {}
}
